var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7513 0.799988H7.24872C3.24842 0.799988 0 4.07383 0 8.10546V23.8945C0 27.9202 3.24842 31.2 7.24872 31.2H30.7513C34.7457 31.2 38 27.9261 38 23.8945V8.10546C38 4.07383 34.7457 0.799988 30.7513 0.799988ZM35.2568 14.0256V23.8945C35.2568 26.3987 33.236 28.4353 30.7513 28.4353H7.24872C4.76395 28.4353 2.74324 26.3987 2.74324 23.8945V13.4336H35.2568V14.0256ZM35.2568 10.0769V10.6689H2.74324V8.10546C2.74324 5.60123 4.76395 3.5647 7.24872 3.5647H30.7513C33.236 3.5647 35.2568 5.60123 35.2568 8.10546V10.0769Z",
    fill: "#253748"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1668 20.5378H7.24875C6.49098 20.5378 5.88007 21.1594 5.88007 21.9172C5.88007 22.675 6.49685 23.2966 7.24875 23.2966H11.1668C11.9246 23.2966 12.5355 22.675 12.5355 21.9172C12.5355 21.1594 11.9187 20.5378 11.1668 20.5378Z",
    fill: "#253748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 30.4,
    fill: "white",
    transform: "translate(0 0.799988)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.f121ec6a5c8b4df1bbfe8582294667d0.svg";
export { ForwardRef as ReactComponent };